import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { Button, Collapse } from 'reactstrap';

import { showModal } from '../../../actions';

import { userIsAdmin, userIsManager } from '../../../helpers/Auth';
import { getInitialOpenOnboardingStep, isOnboardingStepCompleted } from '../../../helpers/Onboarding';

import OnboardingStepHeader from './StepHeader';
import OnboardingSkipButton from './SkipButton';

const OnboardingInviteTeam = ({ openModal, slug }) => {
  const intl = useIntl();

  const [isOpen, setIsOpen] = useState(getInitialOpenOnboardingStep() === slug);

  const isCompleted = isOnboardingStepCompleted(slug);
  const initialOpenStep = getInitialOpenOnboardingStep();

  useEffect(() => {
    if (initialOpenStep === slug) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [slug, initialOpenStep]);

  if (!(userIsAdmin() || userIsManager())) {
    return null;
  }

  return (
    <div className={classnames('onboarding-step', { 'onboarding-step-next': initialOpenStep === slug })}>
      <OnboardingStepHeader
        isOpen={isOpen}
        handleOpen={setIsOpen}
        title={intl.formatMessage({ defaultMessage: 'Invite your team' })}
        subtitle={intl.formatMessage({ defaultMessage: 'Stockpress is better with your team. You have unlimited users - don\'t forget to use them!' })}
        isCompleted={isCompleted}
      />
      <Collapse isOpen={isOpen} className="onboarding-step-collapse">
        <div>
          <div className="onboarding-step-collapse-buttons">
            <div>
              <Button
                color="primary"
                onClick={openModal}
              >
                <i className="fal fa-plus mr-1" />
                {intl.formatMessage({ defaultMessage: 'Invite user' })}
              </Button>
            </div>
            <div>
              <OnboardingSkipButton slug={slug} isCompleted={isCompleted} />
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  openModal: () => {
    dispatch(showModal('UserEditModal', {
      className: 'modal-edit-user',
    }));
  },
});

OnboardingInviteTeam.propTypes = {
  openModal: PropTypes.func.isRequired,
  slug: PropTypes.string.isRequired,
};

export default connect(null, mapDispatchToProps)(OnboardingInviteTeam);
